/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".order-tabs .nav.nav-tabs{border-bottom:1px solid #d0d0d0;margin-bottom:20px}.order-tabs .nav-tabs .nav-item{margin-bottom:0}.order-tabs .nav-tabs .nav-link{border:none;padding:8px 16px;color:#999}.order-tabs .nav-tabs .nav-link.active,.order-tabs .nav-tabs .nav-link.active:hover{border-bottom:4px solid #f18a12;color:#333;font-weight:700}.order-tabs .nav-tabs .nav-link:hover{border-bottom:4px solid #fff1e0;color:#666}"];
export { styles as styles };
